/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_Right_AddressInputs */

const cs_builder_prop_right_address = /** @type {(inputs: Builder_Prop_Right_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pravá adresa`)
};

const en_builder_prop_right_address = /** @type {(inputs: Builder_Prop_Right_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right address field`)
};

/**
* | output |
* | --- |
* | "Right address field" |
*
* @param {Builder_Prop_Right_AddressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_right_address = /** @type {((inputs?: Builder_Prop_Right_AddressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_Right_AddressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_right_address(inputs)
	return cs_builder_prop_right_address(inputs)
});